import script from "./GroupManageIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupManageIndex.vue?vue&type=script&lang=ts&setup=true"

import "./GroupManageIndex.vue?vue&type=style&index=0&id=de762252&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de762252"]])

export default __exports__